import React, { useEffect, useRef, useState } from "react";
import "./DosaChutneyHome.scss"
import heroBackground from "../../assets/images/carousel.png"
import heroBackgroundMob from "../../assets/images/carouselMob.png"
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { useSelector } from "react-redux";
import MapLocationComponent from "../../components/Footer/MapLocationComponent";
import tableBooking from "../../assets/images/tableBooking.jpg"
import border from "../../assets/images/border.png"
import pattern from "../../assets/images/pattern.png"
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import specialMenuImg from "../../assets/images/specialMenu.png"
import MenuSliderComponent from "../../components/MenuSlider/MenuSliderComponent";
import ReviewSlider from "../../components/ReviewSlider/ReviewSlider";



const DosaChutneyHome = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({
        email: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            email: ""
        };

        const trimmedEmail = email.trim();

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.companyID || "",
            "Name": "",
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "Dosa N Chutney",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const images = [
        { "src": "https://plus.unsplash.com/premium_photo-1665669263531-cdcbe18e7fe4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://plus.unsplash.com/premium_photo-1675788938970-e2716f23b1f9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://images.unsplash.com/photo-1534432182912-63863115e106?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1618427012166-b0e03d490a4a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzR8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1609590981063-d495e2914ce4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1580959422798-c487f21d1a08?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTcwfHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
    ]
    useEffect(() => {
        // const container = containerRef.current;
        // const content = contentRef.current;

        // if (!container || !content) return;

        // let scrollLeft = 0;
        // let animationFrame;

        // const clone = content.cloneNode(true);
        // container.appendChild(clone);

        // const animate = () => {
        //     scrollLeft += 0.5;
        //     if (scrollLeft >= content.scrollWidth) {
        //         scrollLeft = 0;// Reset seamlessly
        //     }
        //     container.scrollLeft = scrollLeft;
        //     animationFrame = requestAnimationFrame(animate);
        // };

        // animationFrame = requestAnimationFrame(animate);

        // return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyHome-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyHome-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyHome-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const carousel = [
        {
            "imageUrl": window.screen.width < 900 ? heroBackgroundMob : heroBackground,
            "text": "Authentic South Indian cuisine, freshly prepared by expert chefs. Handcrafted recipes, rich spices, unforgettable taste — only at Dosa n Chutney.",
            "buttonText": "Click & Collect",
            "linkUrl": "",
            "secondaryButtonText": "VIEW MENU",
            "secondaryButtonLinkUrl": "/menu"
        },
        {
            "imageUrl": window.screen.width < 900 ? heroBackgroundMob : heroBackground,
            "text": "Authentic South Indian cuisine, freshly prepared by expert chefs. Handcrafted recipes, rich spices, unforgettable taste — only at Dosa n Chutney.",
            "buttonText": "Click & Collect",
            "linkUrl": "",
            "secondaryButtonText": "VIEW MENU",
            "secondaryButtonLinkUrl": "/menu"

        },
        {
            "imageUrl": window.screen.width < 900 ? heroBackgroundMob : heroBackground,
            "text": "Authentic South Indian cuisine, freshly prepared by expert chefs. Handcrafted recipes, rich spices, unforgettable taste — only at Dosa n Chutney.",
            "buttonText": "Click & Collect",
            "linkUrl": "",
            "secondaryButtonText": "VIEW MENU",
            "secondaryButtonLinkUrl": "/menu"
        },

    ]
    const spacialMenu = [
        {
            "src": "https://media.istockphoto.com/id/1407172002/photo/indian-spicy-mutton-biryani-with-raita-and-gulab-jamun-served-in-a-dish-side-view-on-grey.jpg?s=612x612&w=0&k=20&c=sYldtF2E_cSuYioPtcmM15arsnSs2mIgpuAKUDuuGoI=",
            "title": "Lamb Biryani",
            "description": "Steamed rice cakes with lentil soup",
            "price": "£12.20"
        },
        {
            "src": "https://media.istockphoto.com/id/1319648692/photo/crispy-pancake-made-of-fermented-whole-grain-finger-millet-batter-served-with-cottage-cheese.jpg?s=612x612&w=0&k=20&c=g3AwxEH_7LsACnRlVJIb0eccCSk2qukwJU_NjpaYUHA=",
            "title": "Paneer Dosa",
            "description": "Crispy dosa with spiced potato filling",
            "price": "£5.25"
        },
        {
            "src": "https://media.istockphoto.com/id/1488737993/photo/idly-sambar-or-idli-with-sambhar-and-coconut-chutney-red-chutney-green-chutney-popular-south.jpg?s=612x612&w=0&k=20&c=hZZWP3SyRAzcearXFPuaMfjJRaAkOkcWFzUkEn0MhQI=",
            "title": "Idli Sambar",
            "description": "Steamed rice cakes with lentil soup",
            "price": "£2.25"
        }, {
            "src": "https://media.istockphoto.com/id/1306083166/photo/masala-sin.jpg?s=612x612&w=0&k=20&c=DLrNS6s3FS6Eygy0vbEk0WY0ROMuEyNde6ttwUv_ObA=",
            "title": "Masala Dosa",
            "description": "Crispy dosa with spiced potato filling",
            "price": "£9.45"
        }, {
            "src": "https://media.istockphoto.com/id/1205482272/photo/medu-wada-with-sambar-and-chutney-south-indian-breakfast-or-snack-dish-on-banana-leaf.jpg?s=612x612&w=0&k=20&c=e0f0_ik1YETKco-jJwbbh3vP_GrOD-oh2KucGSUbQOg=",
            "title": "Vada Sambar",
            "description": "Crispy lentil donuts with sambar",
            "price": "£6.80"
        }, {
            "src": "https://media.istockphoto.com/id/1364757902/photo/crispy-crepes-made-of-barnyard-millets-and-lentils-commonly-known-as-barnyard-millet-ghee.jpg?s=612x612&w=0&k=20&c=OujKblDoHPThj7fcxLL1FBfzRNlHK6ZwNYVXnqDhDBU=",
            "title": "Plain Dosa",
            "description": "Classic crispy rice and lentil crepe",
            "price": "£4.50"
        },

    ]
    const reviews = [
        {
            name: "Velupillai Navam", image: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 5

        },
        {
            name: "Clair McEnhill", image: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHVzZXJ8ZW58MHx8MHx8fDA%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 5

        },
        {
            name: "Rebecca Reid", image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dXNlcnxlbnwwfHwwfHx8MA%3D%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 4
        },
        {
            name: "Velupillai Navam", image: "https://images.unsplash.com/flagged/photo-1573740144655-bbb6e88fb18a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHVzZXJ8ZW58MHx8MHx8fDA%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 5

        },
        {
            name: "Clair McEnhill", image: "https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 5

        },
        {
            name: "Rebecca Reid", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D",
            review: "Duis aute irure dolor in reprehenderit in voluptate velit",
            rate: 5

        },
    ];

    const HeaderText = ({ subheader, header, content }) => {
        return (
            <div className="DosaChutneyHome-HeaderText">
                {subheader && <div className="DosaChutneyHome-HeaderText-subheader">
                    {subheader}
                </div>}
                <div className="DosaChutneyHome-HeaderText-header">
                    {header}
                </div>
                <img alt="" src={border} className="DosaChutneyHome-HeaderText-border" />
                {content && <div className="DosaChutneyHome-HeaderText-content">
                    {content}  </div>}
            </div>
        )
    }
    const getMenu = () => {
        return (
            <div className="DosaChutneyHome-Menu">
                <HeaderText
                    subheader={"MEAL DEAL"}
                    header={"Feast Without the Fuss"} />
                <MenuSliderComponent />
            </div>
        )
    }
    const getReviews = () => {
        return (
            <div className="DosaChutneyHome-Menu">
                <HeaderText
                    subheader={"REVIEW"}
                    header={"What Our Client Say"}
                    content={"Discover the first-hand experiences of our valued clients as they share their feedback and testimonials, offering insight into the exceptional service and satisfaction they've encountered with us"} />
                <ReviewSlider
                    items={reviews} />
            </div>
        )
    }
    const getAbout = () => {
        return (
            <div className="DosaChutneyHome-About">
                <div className="DosaChutneyHome-About-left">
                    <div className="DosaChutneyHome-About-left-imgs">
                        <div className="DosaChutneyHome-About-left-imgs-left">
                            <img alt="" src="https://media.istockphoto.com/id/849749746/photo/middle-eastern-meze-platter-with-green-falafel-pita-sun-dried-tomatoes-pumpkin-and-beet-hummus.jpg?s=612x612&w=0&k=20&c=jxRzenS_xqbmHnBOYRziLAzDP1faJMAjvznMUncKM1s=" className="DosaChutneyHome-About-left-imgs-left-web" />
                            <img alt="" src="https://images.unsplash.com/photo-1694849789325-914b71ab4075?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZG9zYXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-left-web" />
                            <img alt="" src="https://images.unsplash.com/photo-1710091691777-3115088962c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2UlMjBhbmQlMjBjdXJyeXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-left-mob" />
                            <img alt="" src="https://media.istockphoto.com/id/2254897372/photo/indian-dish-chicken-biryani-with-basmati-rice.jpg?s=612x612&w=0&k=20&c=En3louo6gNPC555Lin_9GSZCcSS8JnsOo0n30qeFGDQ=" className="DosaChutneyHome-About-left-imgs-left-mob" />
                            <img alt="" src="https://media.istockphoto.com/id/1156896083/photo/cheese-masala-dosa-recipe-with-sambar-and-chutney-selective-focus.jpg?s=612x612&w=0&k=20&c=Wyy0uUGXfQn7JstC8w0DsxWJVGnqWUJUCG53a42UH9s=" className="DosaChutneyHome-About-left-imgs-left-mob" />

                        </div>
                        <img alt="" src="https://images.unsplash.com/photo-1710091691777-3115088962c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2UlMjBhbmQlMjBjdXJyeXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-right" />
                    </div>
                    <img alt="" src="https://media.istockphoto.com/id/2254897372/photo/indian-dish-chicken-biryani-with-basmati-rice.jpg?s=612x612&w=0&k=20&c=En3louo6gNPC555Lin_9GSZCcSS8JnsOo0n30qeFGDQ=" className="DosaChutneyHome-About-left-image" />

                </div>
                <div className="DosaChutneyHome-About-right">
                    <div className="DosaChutneyHome-About-right-cont">
                        <HeaderText
                            subheader={"IN TOOTING"}
                            header={"Dosa n Chutney"} />
                        <div className="DosaChutneyHome-About-right-cont-headerText">
                            Authentic South Indian  Flavours, Celebrated with Passion and Freshness in the Heart of London
                        </div>
                        <div className="DosaChutneyHome-About-right-cont-content">
                            Welcome to Dosa n Chutney, where authentic South Indian cuisine meets contemporary dining in the heart of London. Indulge in crispy dosas, aromatic sambar, and traditional recipes prepared with the finest ingredients, passion, and modern culinary expertise.
                        </div>
                    </div>
                    <img alt="" src="https://media.istockphoto.com/id/1156896083/photo/cheese-masala-dosa-recipe-with-sambar-and-chutney-selective-focus.jpg?s=612x612&w=0&k=20&c=Wyy0uUGXfQn7JstC8w0DsxWJVGnqWUJUCG53a42UH9s=" className="DosaChutneyHome-About-right-imgs" />


                </div>
            </div>
        )
    }
    const getTableBooking = () => {
        return (
            <div className="DosaChutneyHome-TableBooking"
                style={{
                    backgroundImage: `linear-gradient(135deg, #1a330be3, #1a330be3), url(${tableBooking})`
                }}>
                <div className="DosaChutneyHome-TableBooking-subheader">
                    TABLE BOOKING
                </div>
                <div className="DosaChutneyHome-TableBooking-header">
                    Book a Table Now
                </div>
                <img alt="" src={border} className="DosaChutneyHome-TableBooking-border" />
                <div className="DosaChutneyHome-TableBooking-content">
                    Secure your seat and savour the moment. Book a table now for an unforgettable dining experience.
                </div>
                <div className="DosaChutneyHome-TableBooking-button"
                    onClick={() => {
                        // window.open(contnt?.href, '_blank')
                    }}>
                    book now
                </div>
            </div>
        )
    }

    const getSpecialMenu = () => {
        return (<div className="DosaChutneyHome-SpecialMenu"
            style={{
                backgroundImage: `url(${specialMenuImg})`
            }}>
            <div className="DosaChutneyHome-SpecialMenu-inner">
                <HeaderText
                    header={"Today’s Special"} />
                <div className="DosaChutneyHome-SpecialMenu-inner-text">
                    Experience the crispy perfection of our dosas and the rich flavours of our chutneys, taking you on a culinary journey from the streets of Chennai to the heart of Tooting.
                </div>
                <div className="DosaChutneyHome-SpecialMenu-inner-grid">
                    {spacialMenu.map((menuItem, key) => {
                        return (
                            <div className="DosaChutneyHome-SpecialMenu-inner-grid-item" key={key}>
                                <img className="DosaChutneyHome-SpecialMenu-inner-grid-item-img" alt="" src={menuItem?.src} />
                                <div className="DosaChutneyHome-SpecialMenu-inner-grid-item-right">
                                    <div className="DosaChutneyHome-SpecialMenu-inner-grid-item-right-cont">
                                        <div className="DosaChutneyHome-SpecialMenu-title ">
                                            {menuItem?.title}
                                        </div>
                                        <div className="DosaChutneyHome-SpecialMenu-dots" />
                                        <div className="DosaChutneyHome-SpecialMenu-price">
                                            {menuItem?.price}
                                        </div>
                                    </div>
                                    <div className="DosaChutneyHome-SpecialMenu-description">{menuItem?.description}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="DosaChutneyHome-SpecialMenu-button"
                    onClick={() => {
                        // window.open(contnt?.href, '_blank')
                    }} >
                    Order Now
                </div>
            </div>
        </div>)
    }
    const getSubscription = () => {
        return (
            <div className="DosaChutneyHome-Subs"
                style={{
                    backgroundImage: `linear-gradient(135deg, #1a330be3, #1a330be3), url(${pattern})`
                }}>
                <div className="DosaChutneyHome-Subs-subheader">
                    STAY CONNECTED
                </div>
                <div className="DosaChutneyHome-Subs-header">
                    Subscribe to Our Newsletter
                </div>
                <img alt="" src={border} className="DosaChutneyHome-Subs-border" />
                <div className="DosaChutneyHome-Subs-content">
                    Get updates on new products and special offers! </div>
                <div className="DosaChutneyHome-Subs-inputCont">
                    <div>

                        <input className={`DosaChutneyHome-Subs-inputCont-input ${errors.email !== "" ? "error" : ""}`}
                            placeholder={"Enter your email"}
                            onChange={(e) => {
                                setEmail(e.target.value)
                                setErrors({
                                    ...errors,
                                    ["email"]: "",
                                });

                            }}
                            value={email} />
                        {
                            errors.email !== "" && < div className="input-error-text">
                                {errors.email}
                            </div>
                        }</div>
                    <div className="DosaChutneyHome-Subs-inputCont-button"
                        onClick={handleContact}>
                        {loading ? <div
                            className="DosaChutneyHome-Subs-inputCont-button-loader-btn " /> : ""}         Subscribe
                    </div>
                </div>
                {showSuccess && < div className="succes-alert">
                    Subscription successful! Thanks for joining our newsletter. </div>}
            </div>
        )
    }
    return (
        <div className="DosaChutneyHome">
            <div className="DosaChutneyHome-Hero">
                <ImageCarousel
                    content={carousel} />
            </div>
            <div className="DosaChutneyHome-Container">
                {getMenu()}
                {getAbout()}
                {getSpecialMenu()}
                {getSubscription()}
                {getReviews()}
                {getTableBooking()}
            </div>
            <div className="DosaChutneyHome-Map">
                {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                    lng={companyDetails?.address?.lng}
                />}
            </div>
            {getImagesCarousel(images)}
        </div>
    )
}
export default DosaChutneyHome